import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=80045f0c&scoped=true&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=80045f0c&prod&lang=scss&"
import style1 from "./SettingsTab.vue?vue&type=style&index=1&id=80045f0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80045f0c",
  null
  
)

export default component.exports